<p-toast  [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="main-msg-outer">

<div class="date-filter" [formGroup]="filterData">
        <div class="grid">
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="startDateTime">Start Date & Time</label>
                    <div class="custom-select">
                        <p-calendar #startDate [showTime]="true" dateFormat="M dd, yy"
                        inputId="startDateInput"
                        [appEnterKeyListener]="'start'"
                        (keydown.enter)="searchByFilter()"
                        [inputStyle]="{'width':'95%'}" placeholder="Select" formControlName="startDateTime"></p-calendar><img [calendarOpener]="startDate" src="assets/images/date-calender.png" alt="calender"/>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="endDateTime">End Date & Time</label>
                    <div class="custom-select">

                        <p-calendar #endDate [showTime]="true" dateFormat="M dd, yy"
                        inputId="endDateInput"
                        [appEnterKeyListener]="'end'"
                        (keydown.enter)="searchByFilter()"
                            [inputStyle]="{'width':'95%'}" 
                            placeholder="Select" formControlName="endDateTime" ></p-calendar><img [calendarOpener]="endDate" src="assets/images/date-calender.png" alt="calender"/>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2" *ngIf="hideFilterForDriver()">
                <div class="date-outer">
                    <label for="driverName">Driver Name</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input  id="driverNameInput" type="text" pInputText placeholder="Enter Driver Name" formControlName="driverName"  (keydown.enter)="searchByFilter()"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2" *ngIf="hideFilterForDriver()">
                <div class="date-outer">
                    <label for="driverEmail">Email</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input id="driverEmailInput" type="text" pInputText placeholder="Enter Email" formControlName="driverEmail"  (keydown.enter)="searchByFilter()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-2">
                <div class="date-outer">
                    <label for="bookingId">Booking ID</label>
                    <div class="custom-select2">
                        <div class="filter-parking header-filter">
                            <input type="text" pInputText placeholder="Enter Booking ID" formControlName="bookingId" (keydown.enter)="searchByFilter()" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer">
                        <p-button styleClass="p-button" label="Search" (onClick)="searchByFilter()"></p-button>

</div>
                </div>
            </div>
            <div class="col-12 lg:col-1">
                <div class="date-outer-btn">
                    <div class="edit-outer">
                        <p-button styleClass="p-button p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>

                    </div>

                </div>
            </div>

        </div>
    </div>

<div class="inner-msgouter">

        <div class="driver-list-outer">
            <div class="list-heading">
                <h4>Messages List</h4>
                <ul  *ngIf="BookingMessageList?.length > 0 ">
                    <li  class="cursor-pointer" *ngFor=" let data of BookingMessageList" (click)="getBookingMessage(data.bookingId)"
                      [ngClass]="{'list-active': data.bookingId === (selectedBookingId || paramsBookingId)}" >
                      <div class="driver-list1">
                        <div class="driver-img">
                          <img [src]="roleName === userRoles.DRIVER ? (data.companyLogo || dummy) : (data.driverImage || dummy)" alt=""/>
                        </div>
                        <div class="driver-text">
                          <h5>{{ roleName === userRoles.DRIVER ? data.parkingLotName : data.name }}</h5>
                          <p>Booking ID - {{data.invoiceNumber}}</p>
                        </div>
                      </div>
                      
                    </li>

                </ul>
            <div class="msg-no-record" *ngIf="BookingMessageList?.length === 0 ">
                <p>No Message List </p>
            </div>

</div>
        </div>
        
        <div class="msg-outer" [formGroup]="messageGroup">
            <div class="msg-inner">
                <div class="list-heading">
                    <h4>Messages</h4>
                </div>
                <div class="msg-bg">
                    <div class="msg-scroll" #msgScrollContainer *ngIf="messageHistory.length > 0; else noMessages ">
                        <div class="left-side-msg" *ngFor="let message of messageHistory">
                            <div class="left-msg"  *ngIf="isRoleInList(message.role)">
                                <h5>{{ getMessageDisplayName(message.role, message.name)}} <span>{{message.messageTime | messageTimePipe}}</span></h5>
                                <div class="single-bg">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                                        <path d="M0 9.5V0L5.61576 9.5H0Z" fill="white"/>
                                        </svg>
                                    <p>{{ message.content}}</p>
                                </div>
                            </div>
                            
                            <div class="right-msg" *ngIf="message.role === 'Driver'">
                                <div class="inner-msgright">
                                    <div class="left-msg">
                                        <div class="user-img">

                                          <h5>{{ getMessageDisplayName(message.role, message.name)}} <span>{{message.messageTime | messageTimePipe}}</span></h5>
                                         <img [src]="(message.driverImagePath)?message.driverImagePath:dummy" alt=""/>
                                        </div>
                                      
                                        <div class="multi-bg">
                                           
                                            <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"
                                                fill="none">
                                                <path d="M6 9.5V0L0.499179 9.5H6Z" fill="white" />
                                            </svg>
                                            <p>{{message.content}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                       <div class="account-delete"><strong>{{ bookingDetails?.isDriverDeleted ? "The chat has been terminated because the driver's account has been deleted." : ""}}</strong></div> 
                      </div>
                    <ng-template  #noMessages>
                           <div class="no-msg" *ngIf="!startMessage">
                            <div class="nomsg-inner">
                                <img src="../../../../assets/images/no-msg.svg" alt=""/>
                                <h5>No Messages yet</h5>
                                <p *ngIf="startMessageButtonCheck()">Click on Start Message to continue</p>
                                <div class="start-msg">
                                  <button *ngIf="startMessageButtonCheck()"  (click)="startMessageWithUser()" class="btn">Start Message</button>
                                </div>
                            </div>
                         
                            </div>
                            
                    </ng-template>
                    <div *ngIf="!bookingDetails?.isDriverDeleted">
                        <div *ngIf="startMessage || messageHistory.length > 0" class="submit-outer" >
                            <input  type="" (keyup.enter)="createMessage()" placeholder="Type here…"  formControlName="messageContent"/>
                            <img  [class.disabled]="!messageGroup.get('messageContent').value"  (click)="createMessage()" src="../../../../assets/images/send-msg.svg" alt="Send"/>
    
                        </div>
                    </div>
                </div>
            </div>

<div class="booking-info">
                <div class="list-heading">
                    <h4>Booking Details</h4>
                </div>
                <div class="driver-profile-scroll" *ngIf="bookingDetails != null">
                    <div class="truck-profile">
                        <div class="profile-inner">
                            <img [src]="bookingDetails.companyLogo || dummy" alt="Compamy logo"/>
                            <div class="profilr-text">
                                <h4>{{bookingDetails.parkingArea }}</h4>
                                <p>{{bookingDetails.address}}</p>

                            </div>

                        </div>
                        <hr class="custom-hr" />
                        <div class="arrive-main-outer">
                            <div class="arrive-deouter">
                                <div class="arrival-outer">
                                    <p>Arrival</p>
                                    <h4>{{bookingDetails.arrivalTime || '-'}}</h4>

                                </div>
                                <div class="arrival-outer">
                                    <p>Departure </p>
                                    <h4>{{bookingDetails.departureTime || '-'}}</h4>

                                </div>
                            </div>
                            <div class="arrive-deouter">
                                <div class="arrival-outer">
                                    <p>Booking Type </p>
                                    <h4>{{ (bookingDetails.bookingType > 0 || bookingDetails.parentId != null) ? 'Recurring' : 'One Time' }}</h4>

</div>
                                <div class="arrival-outer">
                                    <p>Billing Cycle </p>
                                    <h4>{{bookingDetails.recurringCount}}</h4>

                                </div>
                            </div>
                            <div class="arrive-deouter">
                                <div class="arrival-outer">
                                    <p>{{spotTypeMsg}} </p>
                                    <h4>{{bookingDetails.vehicleType}}</h4>

                                </div>
                                <div class="arrival-outer">
                                    <p>{{bookingDetails.bookingStatus?.label}}</p>
                                    <h5>${{bookingDetails.paidAmount}}</h5>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="driver-details"  *ngIf="hideFilterForDriver()">
                        <div class="driver-heading">
                            <h3>Driver Details</h3>

                        </div>
                        <hr class="custom-hr" />
                        <div class="profile-description">
                            <img [src]="(bookingDetails.driverImage)?bookingDetails.driverImage:dummy" alt="Driver"/>
                            <h3>
                                {{bookingDetails.driverName}}
                            </h3>
                            <p>{{bookingDetails.driverEmail}}</p>
                        </div>
                        <div class="phone-outer">
                            <ul>
                                <li>
                                    <p>Mobile Number</p>
                                    <h5>{{bookingDetails.driverCountryCode}} {{bookingDetails.driverMobile}}</h5>
                                </li>
                                <li class="custom-line"></li>
                                <li>
                                    <p>Registered Since</p>
                                    <h5>{{bookingDetails.dateCreated}}</h5>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="msg-norecord" *ngIf="bookingDetails == null">
                    <p>No Booking Details</p>
                </div>
            </div>
        </div>
    </div>
</div>